import styled from "styled-components";
export default styled.div`
  border-bottom: 2px solid #eee;
  height: min-content;
`;
